import { z } from 'zod';
import { nameRegex, defaultPasswordPolicy } from 'utils/constants';

export const getSignUpPageSchema = (
  t: (key: string, options?: any) => string
) =>
  z
    .object({
      firstName: z
        .string()
        .min(1, t('validation.required'))
        .regex(nameRegex, t('validation.name')),
      lastName: z
        .string()
        .min(1, t('validation.required'))
        .regex(nameRegex, t('validation.name')),
      email: z.email({ error: t('validation.email_address') }),
      password: z
        .string()
        .min(1, t('validation.required'))
        .min(
          defaultPasswordPolicy.minimumLength,
          t('validation.password_minimum_length', {
            minimumLength: defaultPasswordPolicy.minimumLength
          })
        )
        .max(
          defaultPasswordPolicy.maximumLength,
          t('validation.password_maximum_length', {
            maximumLength: defaultPasswordPolicy.maximumLength
          })
        ),
      confirmPassword: z.string().min(1, t('validation.required')),
      group: z.string().optional(),
      country: z
        .string({ error: t('validation.required') })
        .min(1, t('validation.required')),
      language: z
        .string({ error: t('validation.required') })
        .min(1, t('validation.required'))
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: t('validation.confirm_password'),
      path: ['confirmPassword']
    });

export type SignUpFormData = z.infer<ReturnType<typeof getSignUpPageSchema>>;
